<template>
  <div class="index">
   
   <router-view/>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100vw;
  height: 100vh;
}
</style>